import { Injectable } from '@angular/core';
import { TARGET_SITE_PROGRAM } from '@app/shared/constants';
import { TokenStorageService } from '@app/shared/services/token-storage.service';

@Injectable()
export class TargetUrlService {
  constructor(private readonly tokenStorage: TokenStorageService) {}

  public get(path: string): string {
    const targetSiteId = `${TARGET_SITE_PROGRAM.targetSiteId}=${this.tokenStorage.userInfo.CurrentSiteId}`;
    const targetProgramId = `${TARGET_SITE_PROGRAM.targetProgramId}=${this.tokenStorage.userInfo.CurrentProgramId}`;

    return `${path}?${targetSiteId}&${targetProgramId}`;
  }
}
